import { ENCODED_TAG_NAME_ATTR, ENCODED_TAG_VALUE_ATTR, ENCODED_ATTR_NAME_SELECTOR_REGEX } from '../constants.mjs';

function nodeMapToArray(nodeMap) {
  const arr = [];
  for (let i = 0; i < nodeMap.length; ++i) {
    arr.push(nodeMap.item(i));
  }
  return arr;
}
function hasAttributes(element) {
  return element.attributes.length > 0;
}
function extractEncodedData(element) {
  const attributes = nodeMapToArray(element.attributes);
  const extractedTag = {
    name: '',
    value: ''
  };
  const extractedAttributes = [];
  attributes.forEach(attr => {
    const {
      name,
      value
    } = attr;
    if (attr.name === ENCODED_TAG_NAME_ATTR) {
      extractedTag.name = value;
    } else if (attr.name === ENCODED_TAG_VALUE_ATTR) {
      extractedTag.value = value;
    } else if (ENCODED_ATTR_NAME_SELECTOR_REGEX.test(name)) {
      extractedAttributes.push(extractAttributeData(attr));
    }
  });
  return {
    tag: extractedTag,
    attributes: extractedAttributes
  };
}

// Document object is passed in since we use a different document during SSR
function isValidAttributeName(attributeName, documentObject) {
  const ele = documentObject.createElement('div');
  try {
    ele.setAttribute(attributeName, '');
  } catch (error) {
    return false;
  }
  return true;
}
function extractAttributeData({
  name,
  value
}) {
  const extractedName = ENCODED_ATTR_NAME_SELECTOR_REGEX.exec(name);
  return {
    name: extractedName[1],
    value
  };
}

export { extractEncodedData, hasAttributes, isValidAttributeName, nodeMapToArray };
